import api from 'Services/api';

export default async function getSchoolsByCity(cityId) {
  const schools = await api.get(`/school/searchcity/${cityId}`).then((res) => res.data.schools).catch((err) => err);
  return schools;
}
